import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useTypedOpenApi } from '../../providers';
import { publicChecklistQueryOptions } from './publicChecklistQueries';

/**
 * One public checklist and its items, by uuid.
 *
 * `data` is `null` when the checklist is no longer public or no longer exists — a state the details
 * page renders rather than an error it catches.
 */
export const usePublicChecklistQuery = (uuid: string, enabled = true) => {
  const { apiClient } = useTypedOpenApi();

  return useQuery({ ...publicChecklistQueryOptions(apiClient, uuid), enabled: enabled && uuid.length > 0 });
};

/** The suspending flavour, for the mobile details screen's `Suspense` shell. */
export const useSuspensePublicChecklistQuery = (uuid: string) => {
  const { apiClient } = useTypedOpenApi();

  return useSuspenseQuery(publicChecklistQueryOptions(apiClient, uuid));
};
